import { useState } from 'react';
import Header from '../Header';
import PageContent from '../PageContenet';
import Sidebar from '../Sidebar';
import useFetchData from '../../hooks/useFetchData';
import GlobalContext from '../../contexts/index';
import translating from './translate.json';
import PropTypes from 'prop-types';
import EditMeasure from '../Customers/componenets/Measures/edit';
import Drawer from '../Drawer';
import './style.scss';
import usePostData from 'hooks/usePostData';
import { HealthCoachSummey } from 'components/Survey/HealthCoachSummey';

const Dashboard = ({ currentUser }) => {
  const [link, setLink] = useState();
  const [city, setCity] = useState(null);
  const [clientProductStageId, setClientProductStageId] = useState();
  const [currentMeetingDetails, setCurrentMeetingsDetails] = useState();
  const [steppersData, setSteppersData] = useState(null);
  const [currentCustomer, setCurrentCustomer] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [currentMeeting, setCurrentMeeting] = useState();
  const [measuresData, setMeasuresData] = useState();
  const [currentProduct, setCurrentProduct] = useState({});
  const [globalProductInfo, setGlobalProductInfo] = useState([]);
  const { data: categoriesList } = useFetchData('category');
  const { data: organizationsList } = useFetchData('organization');
  const { res: productsList } = usePostData('product/get_products');
  const regionEnum = [
    { id: 'כללי', name: 'כללי' },
    { id: 'צפון', name: 'צפון' },
    { id: 'מרכז', name: 'מרכז' },
    { id: 'דרום', name: 'דרום' }
  ];
  const typeEnum = [
    { id: 'ידני', name: 'ידני' },
    { id: 'הרשמה', name: 'הרשמה' }
  ];
  const sourceList = [
    { id: 'אורגני', name: 'אורגני' },
    { id: '1 פרסום', name: '1 פרסום' },
    { id: 'פייסבוק', name: 'פייסבוק' },
    { id: 'טוויטר', name: 'טוויטר' },
    { id: 'אינסטגרם', name: 'אינסטגרם' }
  ];
  let menuData = [
    {
      link: {
        key: 'clients',
        value: translating.customers,
        rules: [
          'Admin',
          'Sales',
          'Medical Staff',
          'Manager',
          'Therapist',
          'Gen Lab',
          'Blood Lab',
          'Service'
        ]
      },
      children: [
        {
          link: {
            key: 'clients',
            value: translating.customersList,
            rules: [
              'Service',
              'Admin',
              'Sales',
              'Medical Staff',
              'Manager',
              'Therapist',
              'Gen Lab',
              'Blood Lab'
            ]
          }
        },
        {
          link: {
            key: 'clients',
            view: 'view',
            value: translating.customer,
            rules: [
              'Admin',
              'Sales',
              'Medical Staff',
              'Manager',
              'Therapist',
              'Gen Lab',
              'Blood Lab'
            ]
          }
        },
        {
          link: {
            key: 'clients',
            view: 'add',
            value: translating.addCustomer,
            rules: ['Admin', 'Sales', 'Manager']
          }
        }
      ]
    },
    {
      link: {
        key: 'organizations',
        value: translating.organizations,
        rules: ['Admin']
      },
      children: [
        {
          link: { key: 'organizations', value: translating.organizationsList }
        },
        {
          link: {
            key: 'organizations',
            view: 'add',
            value: translating.addOrganization
          }
        },
        {
          link: {
            key: 'organizations',
            view: 'view',
            value: translating.organization
          }
        }
      ]
    },
    {
      link: {
        key: 'therapists',
        value: translating.therapists,
        rules: [
          'Admin',
          'Sales',
          'System',
          'Medical Staff',
          'Manager',
          'Gen Lab',
          'Blood Lab',
          'Service'
        ]
      },
      children: [
        {
          link: {
            key: 'therapists',
            value: translating.therapistsList,
            rules: [
              'Admin',
              'Sales',
              'System',
              'Medical Staff',
              'Manager',
              'Gen Lab',
              'Blood Lab',
              'Service'
            ]
          }
        },
        {
          link: {
            key: 'therapists',
            view: 'add',
            value: translating.addTherapist,
            rules: ['Admin', 'System', 'Manager', 'Service']
          }
        },
        {
          link: {
            key: 'therapists',
            view: 'view',
            value: translating.therapist,
            rules: [
              'Admin',
              'Sales',
              'System',
              'Medical Staff',
              'Manager',
              'Gen Lab',
              'Blood Lab',
              'Service'
            ]
          }
        }
      ]
    },
    {
      link: {
        key: 'meetings',
        value: translating.meetings,
        rules: ['Admin', 'Therapist']
      }
    },
    {
      link: {
        key: 'products',
        value: translating.products,
        rules: ['Admin', 'Sales', 'System', 'Manager', 'Service']
      },
      children: [
        {
          link: {
            key: 'products',
            value: translating.productsList,
            rules: ['Admin', 'Sales', 'System', 'Manager', 'Service']
          }
        },
        {
          link: {
            key: 'products',
            view: 'add',
            value: translating.addProduct,
            rules: ['Admin', 'Sales', 'System', 'Manager', 'Service']
          }
        },
        {
          link: {
            key: 'products',
            view: 'view',
            value: translating.product,
            rules: ['Admin', 'Sales', 'System', 'Manager', 'Service']
          }
        }
      ]
    },
    {
      link: { key: 'users', value: translating.manageUsers, rules: ['Admin'] },
      children: [
        {
          link: { key: 'users', value: translating.usersList, rules: ['Admin'] }
        },
        {
          link: {
            key: 'users',
            view: 'add',
            value: translating.addUser,
            rules: ['Admin']
          }
        },
        {
          link: {
            key: 'users',
            view: 'view',
            value: translating.user,
            rules: ['Admin']
          }
        }
      ]
    },
    {
      link: {
        key: 'notifications',
        value: translating.notifications,
        rules: ['Admin']
      },
      children: [
        {
          link: {
            key: 'notifications/genetic',
            value: 'גנטי-הודעות',
            rules: ['Admin']
          }
        },
        {
          link: {
            key: 'notifications/survey',
            value: 'סקר-הודעות',
            rules: ['Admin']
          }
        }
      ]
    },
    {
      link: {
        key: 'labs',
        value: 'מעבדות-גנטי',
        rules: ['Admin', 'Gen Lab', 'Blood Lab']
      },
      children: [
        {
          link: {
            key: 'labs',
            rules: ['Admin', 'Blood Lab'],
            value: 'לקוחות במעבדה'
          }
        },
        {
          link: {
            key: 'labs/blood',
            rules: ['Admin', 'Blood Lab', 'Gen Lab'],
            value: 'טווח בדיקות'
          }
        },
        {
          link: { key: 'labs/gene', rules: ['Admin', 'Gen Lab'], value: 'גנים' }
        },
        {
          link: {
            key: 'labs/report',
            rules: ['Admin', 'Blood Lab', 'Gen Lab'],
            value: 'קטגוריות'
          }
        }
      ]
    },
    {
      link: {
        key: 'survey',
        value: 'מעבדות-סקר',
        rules: ['Admin', 'Gen Lab', 'Blood Lab']
      },
      children: [
        {
          link: {
            key: 'survey/measures',
            rules: ['Admin', 'Blood Lab'],
            value: 'מדדים'
          }
        },
        {
          link: {
            key: 'survey/lab',
            rules: ['Admin', 'Blood Lab', 'Gen Lab'],
            value: 'בדיקות מעבדה'
          }
        },
        {
          link: {
            key: 'survey/additional',
            rules: ['Admin', 'Gen Lab'],
            value: 'בדיקות נוספות'
          }
        },
        {
          link: {
            key: 'survey/texts',
            rules: ['Admin', 'Blood Lab'],
            value: 'טקסטים לדוח סיכום'
          }
        }
      ]
    },
    {
      link: {
        key: 'pre-diabetes',
        value: 'מעבדות-טרום סכרת',
        rules: ['Admin', 'Gen Lab', 'Blood Lab']
      },
      children: [
        {
          link: {
            key: 'pre-diabetes/measures',
            rules: ['Admin'],
            value: 'מדדים'
          }
        },

        {
          link: {
            key: 'pre-diabetes/texts',
            rules: ['Admin'],
            value: 'טקסטים לדוח סיכום'
          }
        }
      ]
    },
    {
      link: { key: 'reports', value: translating.reports, rules: ['Admin'] },
      children: [
        {
          link: {
            key: 'reports/cycle',
            value: translating.cycle,
            rules: ['Admin']
          }
        },
        {
          link: {
            key: 'reports/genetic',
            value: translating.geneticMissingDetails,
            rules: ['Admin']
          }
        },
        {
          link: {
            key: 'reports/analysisBloodTests',
            value: translating.analysisBloodTests,
            rules: ['Admin']
          }
        },
        {
          link: {
            key: 'reports/analysisGeneticTests',
            value: translating.analysisGeneticTests,
            rules: ['Admin']
          }
        },
        {
          link: {
            key: 'reports/analysisQuestions',
            value: translating.analysisQuestions,
            rules: ['Admin']
          }
        },
        {
          link: {
            key: 'reports/analysisMeetings',
            value: translating.analysisMeetings,
            rules: ['Admin']
          }
        }
      ]
    },
    {
      link: {
        key: 'reportsSurvey',
        value: translating.reportsSurvey,
        rules: ['Admin']
      },
      children: [
        {
          link: {
            key: 'reportsSurvey/surveyWaitingDoctor',
            value: translating.surveyWaitingDoctor,
            rules: ['Admin']
          }
        }
      ]
    },
    {
      link: {
        key: 'reportsPreDiabetes',
        value: translating.reportsPreDiabetes,
        rules: ['Admin', 'Therapist']
      },
      children: [
        {
          link: {
            key: 'reportsPreDiabetes/waitingDoctor',
            value: translating.waitingDoctor,
            rules: ['Admin', 'Therapist']
          }
        },
        {
          link: {
            key: 'reportsPreDiabetes/waitingGeneralSummery',
            value: translating.waitingGeneralSummery,
            rules: ['Admin', 'Therapist']
          }
        },
        {
          link: {
            key: 'reportsPreDiabetes/orgDashboard',
            value: translating.orgDashboard,
            rules: ['Admin', 'Therapist']
          }
        }
      ]
    }
  ];
  const value = {
    currentUser,
    currentCustomer,
    setCurrentCustomer,
    openDrawer,
    setOpenDrawer,
    measuresData,
    setMeasuresData,
    setCurrentMeeting,
    currentMeeting,
    menuData,
    link,
    setLink,
    clientProductStageId,
    setClientProductStageId,
    currentMeetingDetails,
    setCurrentMeetingsDetails,
    city,
    setCity,
    categoriesList,
    currentProduct,
    setCurrentProduct,
    organizationsList,
    productsList,
    steppersData,
    setSteppersData,
    regionEnum,
    typeEnum,
    sourceList,
    globalProductInfo,
    setGlobalProductInfo
  };

  return (
    <GlobalContext.Provider value={value}>
      <div className="dashboard">
        <Header></Header>
        <div className="content">
          <Sidebar></Sidebar>
          <PageContent></PageContent>
        </div>
        <Drawer
          variant="persistent"
          anchor="right"
          open={openDrawer}
          onClose={() => {
            setCurrentMeeting(false);
            setOpenDrawer(false);
          }}
        >
          <div className="wrapper-drawer">
            {(() => {
              switch (openDrawer) {
                case 'editMesaure':
                  return <EditMeasure></EditMeasure>;
                case 'healthCoachSummery':
                  return <HealthCoachSummey></HealthCoachSummey>;
              }
            })()}
          </div>
        </Drawer>
      </div>
    </GlobalContext.Provider>
  );
};

export default Dashboard;

Dashboard.propTypes = {
  currentUser: PropTypes.object
};
